<template>
  <div class="button">
    <div  @click="toInquiry">
      <div>
        <img style="width:20px;height:20px" src="@/assets/hideBox/xunjia.png" alt />
        <span>询价</span>
      </div>
    </div>
    <inquiryDialog :detailNo="item" :inquirer="inquirer" :isShowsDialog.sync="editshow" ref="memberEdit" v-if="editshow"></inquiryDialog>
  </div>
</template>

<script>
import {checkDataStatusMessage} from "@/utils/checkDataStatus"
import { mapState } from "vuex"
import { apiResignAll } from "@/api/apiResignAll"
export default {
  name: "inquiryBtn",
  inject:['cardListCom'],
  props:{
    item:Object
  },
  data(){
    return{
      editshow: false,
      inquirer:'',
    }
  },
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo,
      teamNo: state => state.user.teamNo,
      companyName: state => state.user.companyName,
      teamName: state => state.user.teamName,
      name: state => state.user.realName,
    })
  },
  components:{
    inquiryDialog: () => import("@/views/ConstructionTeamDetail/components/inquiryDialog"), // 询价
  },
  methods:{
    async toInquiry(){
      //校验数据有效性
      if (this.permissionTips()) return
      let no = this.item.no
      const dataState = await checkDataStatusMessage.call(this,this.$parent.type,no)
      if(!dataState || dataState!=1){
        return
      }
      if(this.item.userNo===this.userNo){
        this.$message.error('操作失败，不能对自己发布的内容进行该操作')
        return
      }
      if(this.item.companyNo===this.companyNo||(this.item.teamNo&&this.item.teamNo===this.teamNo)){
        this.$message.error('操作失败，不能对同企业/团队发布的内容进行该操作')
        return
      }
      let res = await apiResignAll.checkQueryPrice(this.item.no)
      if(res.data.data){
        this.$message.error('该工队已经询过价，请勿重复询价')
        return
      }
      this.inquirer=this.companyName?this.companyName+'-'+this.name:this.teamName?this.teamName+'-'+this.name:this.name
      this.editshow=true
    }
  }
}
</script>